import React from 'react';
import PropTypes from 'prop-types';
import { useInView } from 'react-intersection-observer';

import { trackEvent } from 'utils/analyticsUtils';

const defaultUseInViewOptions = {
    triggerOnce: true,
    rootMargin: '0px 0px',
};

function TrackInView({ as, children, eventName, eventProperties, useInViewOptions, ...restProps }) {
    const Wrapper = as;

    const { ref } = useInView({
        ...defaultUseInViewOptions,
        onChange: (inView) => {
            if (inView) {
                trackEvent(eventName, eventProperties);
            }
        },
        ...useInViewOptions,
    });

    return (
        <Wrapper ref={ref} {...restProps}>
            {children}
        </Wrapper>
    );
}

TrackInView.propTypes = {
    as: PropTypes.string,
    eventName: PropTypes.string.isRequired,
    eventProperties: PropTypes.shape({}),
    useInViewOptions: PropTypes.shape({}),
};

TrackInView.defaultProps = {
    as: 'div',
    eventProperties: {},
    useInViewOptions: {},
};

export default TrackInView;
